import "@/product-ux.css";

const TONES = new Set(["success", "warning", "info", "danger", "neutral"]);

export const ProductStatus = ({ as: Element = "span", tone = "neutral", icon: Icon, children, testId, className = "", ...props }) => (
  <Element
    className={`product-ux-status product-ux-status--${TONES.has(tone) ? tone : "neutral"} ${className}`}
    data-testid={testId}
    {...props}
  >
    {Icon && <Icon aria-hidden="true" className="w-3.5 h-3.5 shrink-0" strokeWidth={1.8} />}
    <span>{children}</span>
  </Element>
);